import { render, staticRenderFns } from "./MetaLeadsChannels.vue?vue&type=template&id=6e5917b1&scoped=true"
import script from "./MetaLeadsChannels.vue?vue&type=script&lang=js"
export * from "./MetaLeadsChannels.vue?vue&type=script&lang=js"
import style0 from "./MetaLeadsChannels.vue?vue&type=style&index=0&id=6e5917b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5917b1",
  null
  
)

export default component.exports